import styled from "styled-components";

export const ContainerData = styled.div`
  border: 1px solid #f9ae17;
  padding: 10px 15px;
  border-radius: 10px;
`;

export const LabelData = styled.span`
  font-weight: bold;
  color: #203b34;
  margin-right: 10px;
`;
